var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImage2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#08c",
    d: "M128 47.15c-44.65 0-80.85 36.2-80.85 80.85v128.01h47.16V127.99c0-18.6 15.08-33.69 33.69-33.69s33.69 15.08 33.69 33.69-15.08 33.69-33.69 33.69a33.58 33.58 0 0 1-23.86-9.9v53.49a81 81 0 0 0 23.86 3.58c44.65 0 80.85-36.2 80.85-80.85S172.65 47.15 128 47.15"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage2);
export default __webpack_public_path__ + "static/media/image2.1605484746d4eac64ee8806399559a2e.svg";
export { ForwardRef as ReactComponent };